module.exports = __webpack_public_path__ + "img/i_star_on.c21d2954.svg";